export default __webpack_public_path__ + "static/media/menu-vert.b9157deb.svg";